import { Table, TableHead, TableBody, TableRow, TableCell, Typography } from '@material-ui/core';
import TimerIcon from '@material-ui/icons/Timer';
import StatSection from './StatSection';
import useTableRules from '../../UI/useTableRules';
import durationToString from '../../../utils/durationToString';

// How long into a match the contestant got to their 1st, 2nd, ... 5th solve of
// it. A row is a dash when they never got that far in any match.
function PaceCard(props) {
    const rules = useTableRules();
    const pace = props.pace ?? [];
    return (
        <StatSection
            icon={<TimerIcon />}
            title='Pace'
            contentProps={{ p: 0 }}
        >
            <Table size='small' className={rules.ruled}>
                <TableHead>
                    <TableRow>
                        <TableCell> <Typography variant='body2' noWrap> Solve Count </Typography> </TableCell>
                        <TableCell align='right'> <Typography variant='body2' noWrap> Fastest Time</Typography> </TableCell>
                        <TableCell align='right'> <Typography variant='body2' noWrap> Average Time</Typography> </TableCell>
                        <TableCell align='right'> <Typography variant='body2' noWrap> Attained </Typography> </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {pace.map(row => (
                        <TableRow key={row.solves}>
                            <TableCell> <Typography variant='body2' noWrap> {row.solves} </Typography> </TableCell>
                            <TableCell align='right'> <Typography variant='body2' noWrap> {durationToString(row.fastest)} </Typography> </TableCell>
                            <TableCell align='right'> <Typography variant='body2' noWrap> {durationToString(row.average)} </Typography> </TableCell>
                            <TableCell align='right'>
                                <Typography variant='body2' color='textSecondary' noWrap>
                                    {row.matches ? row.matches : '—'}
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </StatSection>
    );
}

export default PaceCard;
